import { Dispatch } from 'redux';
import localStorage from 'redux-persist/es/storage';
import * as actions from '../../store/modules/auth/actions';

export const handleGoogleLogin = (roleId: number) => {
  const oauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';

  const form = document.createElement('form');
  form.setAttribute('method', 'GET');
  form.setAttribute('action', oauth2Endpoint);
  localStorage.setItem('loginProfileId', roleId.toString());

  const formParams: Record<string, string> = {
    client_id:
      '976958137573-4u51ra3ihnh8tkp1lfq648r784d9ns5g.apps.googleusercontent.com',
    redirect_uri: process.env.REACT_APP_GREDIRECT || '',
    response_type: 'token',
    scope:
      'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
    include_granted_scopes: 'true',
    state: roleId.toString(),
    prompt: 'select_account',
    hd: 'escola.pr.gov.br',
  };

  Object.keys(formParams).forEach((key) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute('value', formParams[key]);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

export const handleRedacaoLogin = async (token: string, dispatch: Dispatch) => {
  try {
    if (token) {
      dispatch(actions.loginRequest({ token, loginProvider: 'web' }));
    }
  } catch (error) {
    console.log('handleRedacaoLogin...', error);
  } finally {
    localStorage.removeItem('loginProfileId');
  }
};
